import type { ReactNode } from "react";
import { Box } from "@dealer-center/core-components";

export interface ViewLockFieldProps {
  isLocked: boolean;
  children: ReactNode;
}

// Tab must still move focus (no keyboard trap); Escape must still close the Modal.
const ALLOWED_KEYS = new Set(["Tab", "Escape"]);

// Locks fields without Interstate's disabled/readOnly look. The overlay blocks
// clicks, incl. Chrome's date picker, which preventDefault() alone can't stop.
export const ViewLockField = ({ isLocked, children }: ViewLockFieldProps) =>
  isLocked ? (
    <Box
      sx={{ position: "relative", width: "100%" }}
      onClickCapture={e => {
        e.stopPropagation();
        e.preventDefault();
      }}
      onKeyDownCapture={e => {
        if (ALLOWED_KEYS.has(e.key)) return;
        e.stopPropagation();
        e.preventDefault();
      }}
      onMouseDownCapture={e => {
        e.stopPropagation();
        e.preventDefault();
      }}
      onPasteCapture={e => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      {children}
      <Box
        aria-hidden="true"
        data-testid="view-lock-field-overlay"
        sx={{
          bottom: 0,
          left: 0,
          position: "absolute",
          right: 0,
          top: 0,
          zIndex: 1
        }}
      />
    </Box>
  ) : (
    <>{children}</>
  );
